import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { RegistrationComponent } from './registration/registration.component';
import { CompleteBasicProfileComponent } from './complete-basic-profile/complete-basic-profile.component';
import { HttpClientModule } from '@angular/common/http';

import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { DhwaniLoginDefaultModule } from 'dhwani-login-default';
import { LeftSidePanelComponent } from './components/left-side-panel/left-side-panel.component';
import { RegCommonFormComponent } from './components/reg-common-form/reg-common-form.component';
import { RegFormHeaderComponent } from './components/reg-form-header/reg-form-header.component';
import { RegistrationFormComponent } from './components/registration-form/registration-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { SharedModuleModule } from '../shared-module/shared-module.module';
import { MatDialogModule } from '@angular/material/dialog';
import { ProfileProgressComponent } from './components/profile-progress/profile-progress.component';
import { DetailedRegistrationComponent } from './detailed-registration/detailed-registration.component';
import { LeftDetailedPanelComponent } from './components/left-detailed-panel/left-detailed-panel.component';
import { DetailedRegistrationFormComponent } from './components/detailed-registration-form/detailed-registration-form.component';
import { PaymentSummaryComponent } from './components/payment-summary/payment-summary.component';
import { ProgressBarRegisterComponent } from './components/progress-bar-register/progress-bar-register.component';
import { PaymentComponent } from './payment/payment.component';
import { LeftPaymentPanelComponent } from './components/left-payment-panel/left-payment-panel.component';
import { LoginDefaultComponent } from './components/login-default/login-default.component';
import { RegisterTermsConditionComponent } from './components/register-terms-condition/register-terms-condition.component';
import { PaymentGatewayComponent } from './components/payment-gateway/payment-gateway.component';
import { UploadProgressComponent } from './components/upload-progress/upload-progress.component';
import { PaymentReceiptComponent } from './components/payment-receipt/payment-receipt.component';
// import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
// import { NgCircleProgressModule } from 'ng-circle-progress';
// import { ResetPasswordComponent } from './reset-password/reset-password.component';

@NgModule({
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    RegistrationComponent,
    CompleteBasicProfileComponent,
    ResetPasswordComponent,
    // RegistrationDialogComponent,
    LeftSidePanelComponent,
    RegCommonFormComponent,
    RegFormHeaderComponent,
    RegistrationFormComponent,
    ProfileProgressComponent,
    DetailedRegistrationComponent,
    LeftDetailedPanelComponent,
    DetailedRegistrationFormComponent,
    PaymentSummaryComponent,
    ProgressBarRegisterComponent,
    PaymentComponent,
    LeftPaymentPanelComponent,
    LoginDefaultComponent,
    ResetPasswordComponent,
    RegisterTermsConditionComponent,
    PaymentGatewayComponent,
    UploadProgressComponent,
    PaymentReceiptComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    DhwaniLoginDefaultModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModuleModule,
    MatDialogModule,
    
    // NgCircleProgressModule.forRoot({
    //   // set defaults here
    //   radius: 100,
    //   outerStrokeWidth: 16,
    //   innerStrokeWidth: 8,
    //   outerStrokeColor: "#78C000",
    //   innerStrokeColor: "#C7E596",
    //   animationDuration: 300,
    // })
  ],
  exports: [RegCommonFormComponent]
  // entryComponents:[RegistrationDialogComponent]
})
export class AuthModuleModule { }
